import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, Verification, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { Form, Input, Icon, Button, Alert } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';
import { authorizeByCode, company, bindContinueAuthorize } from 'kts-platform-frame/api';
import { history } from 'kts-platform-frame/routes';

const css = require('./index.scss');
const formItemLayout = {
    wrapperCol: {
        span: 24
    },
};

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    code: string;
}

class UIWxLoginState {
    public isShow: boolean = false;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIWxLogin extends UIBasic<IProps, ModulesState, UIWxLoginState> {

    private ticket: string;

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = new UIWxLoginState();
    }

    componentDidMount() {
        this.wxLogin();
    }

    render() {
        const { form, loadingUrls } = this.props;
        const { getFieldDecorator } = form;

        if (this.state.isShow === false) {
            return null;
        }

        return (
            <div className={css.loginBox}>
                <img src="/img/logo.png" alt="宜迅联" className={css.loginLogo} />
                <div className={css.uipanel}>
                    {/* <div className={css.title}></div> */}
                    <Form>
                        <Form.Item {...formItemLayout}>
                            {getFieldDecorator('identifier', {
                                rules: [{ required: true, message: 'FA TMGP用户名不能为空' }],
                            })(
                                <Input
                                    className={css.user}
                                    placeholder="请输入FA TMGP用户名"
                                    prefix={<Icon type="user" style={{ color: '#A5A5A5', fontSize: '20px' }} />}
                                />
                            )}
                        </Form.Item>
                        <div>
                            <Form.Item {...formItemLayout}>
                                {getFieldDecorator('credential', {
                                    rules: [{ required: true, message: 'FA TMGP密码不能为空' }],
                                })(
                                    <Input
                                        className={css.user}
                                        type="password"
                                        placeholder="请输入FA TMGP密码"
                                        prefix={<Icon type="lock" style={{ color: '#A5A5A5', fontSize: '20px' }} />}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <Form.Item>
                            <div className={css.submit}>
                                <Button loading={loadingUrls.size > 0} onClick={this.onClickLanding} type="primary" htmlType="submit">
                                    绑定微信
                                </Button>
                            </div>
                            <Alert message="您正在将FA TMGP的账号与微信账号进行绑定" type="warning" showIcon={true} style={{ marginTop: 20 }} />
                        </Form.Item>
                    </Form>
                </div>
                {/* <div className={css.footer}>
                    <div className={css.hotLine}>
                        <Icon type="dianhua" style={{ color: '#BCC7D3', fontSize: '18px', marginRight: '10px' }} /><span>服务热线 ：400-836-3566 &nbsp;|</span>
                        <Icon type="xiaoxi1" style={{ color: '#BCC7D3', fontSize: '18px', marginLeft: '10px', marginRight: '10px' }} /><span>support@kingxunlian.com</span>
                    </div>
                    <div className={css.adress}>迅联集团 2018 粤ICP备17007740号-1</div>
                </div> */}
            </div>
        );
    }

    private onClickLanding = () => {
        this.props.form.validateFields(async (er, values) => {
            const bindContinueAuthorizeData = await bindContinueAuthorize(this, { ...values, ticket: this.ticket });
            if (bindContinueAuthorizeData.er) {
                return;
            }

            const { user } = MyStore.instance.getState();
            user.cToken = bindContinueAuthorizeData.res.token;
            MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);

            // 获取用户数据
            const userInfoData = await company.userInfo(this);
            if (userInfoData.er) {
                Verification.instance.start();
                return;
            }

           /** 去除当前登录用户的新手体验提示查看状态 */
            ModulesAction.setGuideTipState();

            history.push(`/workbench/m/Kingxunlian.NewsFeed`);
        });
    }

    private wxLogin = async () => {
        Verification.instance.stop();

        const authorizeByCodeData = await authorizeByCode(this, { code: this.props.code, appId: 'wx6e7d50d886fdd681' });
        if (authorizeByCodeData.er) {
            Verification.instance.start();
            this.setState({ isShow: true });
            return;
        }

        if (authorizeByCodeData.res.token) {

            const { user } = MyStore.instance.getState();
            user.cToken = authorizeByCodeData.res.token;
            MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);

            // 获取用户数据
            const userInfoData = await company.userInfo(this);
            if (userInfoData.er) {
                Verification.instance.start();
                this.setState({ isShow: true });
                return;
            }

            /** 去除当前登录用户的新手体验提示查看状态 */
            ModulesAction.setGuideTipState();

            history.push(`/workbench/m/Kingxunlian.NewsFeed`);
        } else {
            this.ticket = authorizeByCodeData.res.ticket;
        }

        this.setState({ isShow: true });
        Verification.instance.start();
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/UI.WxLogin.tsx